import { BaseSetting } from './base-setting.model';
import { KeyValuePair } from './key-value-pair.model';
import { PauseSettingDao } from './pause-setting-dao.model';

export class UrpSettingDao extends BaseSetting {
  constructor(settings: KeyValuePair[]) {
    super(settings);

    //Urp-Pausenvorgabe
    this.urpVorgabePausen = this.getValue<PauseSettingDao[]>('urpVorgabePausen', [
      new PauseSettingDao('Vormittag', '09:00', '09:15'),
      new PauseSettingDao('Mittag', '12:00', '13:00'),
      new PauseSettingDao('Nachmittag', '15:00', '15:15'),
    ]);

    this.datenLetzterRapportUebernehmen = !!+this.getValue<string>('urpVorgabeVortag', '0');
    this.vorgabeKbsUebernehmen = !!+this.getValue<string>('urpKbUebernehmen', '0');
    this.regieKbsUebernehmen = !!+this.getValue<string>('regieKbUebernehmen', '1');
    this.materialKbsUebernehmen = !!+this.getValue<string>('urpKbUebernehmenM', '1');
    this.inventarKbsUebernehmen = !!+this.getValue<string>('urpKbUebernehmenI', '1');
    this.fremdleistungKbsUebernehmen = !!+this.getValue<string>('urpKbUebernehmenF', '1');
  }

  urpVorgabePausen: PauseSettingDao[];
  datenLetzterRapportUebernehmen: boolean;
  vorgabeKbsUebernehmen: boolean;
  regieKbsUebernehmen: boolean;
  materialKbsUebernehmen: boolean;
  inventarKbsUebernehmen: boolean;
  fremdleistungKbsUebernehmen: boolean;

  public override getSettings(): KeyValuePair[] {
    return [
      new KeyValuePair('urpVorgabePausen', JSON.stringify(JSON.stringify(this.urpVorgabePausen))),
      new KeyValuePair('urpVorgabeVortag', JSON.stringify(this.datenLetzterRapportUebernehmen ? '1' : '0')),
      /* gem:7925 */
      new KeyValuePair('urpKbUebernehmen', JSON.stringify(this.vorgabeKbsUebernehmen ? '1' : '0')),
      new KeyValuePair('regieKbUebernehmen', JSON.stringify(this.regieKbsUebernehmen ? '1' : '0')),
      new KeyValuePair('urpKbUebernehmenM', JSON.stringify(this.materialKbsUebernehmen ? '1' : '0')),
      new KeyValuePair('urpKbUebernehmenI', JSON.stringify(this.inventarKbsUebernehmen ? '1' : '0')),
      new KeyValuePair('urpKbUebernehmenF', JSON.stringify(this.fremdleistungKbsUebernehmen ? '1' : '0')),
    ];
  }
}
